module.exports = __webpack_public_path__ + "static/media/mobbanner1.070b1f43.jpg";